import React from 'react';
import {Link, Control} from 'MWC';
import {LANG} from '../../../../services/l10n';
import "../../less/landing/kdv-new.less"
import Banner from "../../../../auxiliary-components/shared/Banner";
import kdv_usage_block_data from "../enums/kdv_usage_block_data.json"
import TabsNew from "../../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../../auxiliary-components/shared/UsageBlock";
import Table from "../../../../auxiliary-components/shared/Table";
import kdv_table_data from "../../templates/enums/kdv_table_data.json";
import share_icon from "../../ProjectSupport/img/share_icon.svg";
import DownloadApp from "../../views/downloadApp.c";
import QuestionsBlock from "../../../../auxiliary-components/shared/QuestionsBlock";
import kdv_questions from "../../templates/enums/kdv_questions.json";
import FilesForDownload from "../../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import metaData from '../../../../metaData.json';
import { Helmet } from "react-helmet";

export default function template() {
    const isMobile = this.isViewportMobile(),
        modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'tariffs', title: 'GREEN_CARD_NAV_TITLE_2'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
        page = 'kdv-card',
     currentPath = window.location.pathname,
      meta = metaData[currentPath] || '',
        tariffsKDV =
            this.props.lang === LANG.UA
                ? 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/KDV_ua.pdf'
                : 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/KDV_ru.pdf';


    const app = (
        <div className="download-app-wrapper">
            <DownloadApp {...this.props} />
        </div>
    );

    return (
        <>
            {
                meta ?
                  <Helmet>
                      <title>{meta.title}</title>
                      <meta name="description" content={meta.description} />
                      <meta name="keywords" content={meta.keywords} />

                      {/* Open Graph */}
                      <meta property="og:type" content={meta.og?.type} />
                      <meta property="og:url" content={meta.og?.url} />
                      <meta property="og:site_name" content={meta.og?.site_name} />
                      <meta property="og:title" content={meta.og?.title} />
                      <meta property="og:description" content={meta.og?.description} />
                      <meta property="og:image" content={meta.og?.image?.url} />
                      <meta property="og:image:type" content={meta.og?.image?.type} />
                      <meta property="og:image:width" content={meta.og?.image?.width} />
                      <meta property="og:image:height" content={meta.og?.image?.height} />
                      <meta property="og:image:alt" content={meta.og?.image?.alt} />
                      <meta property="og:locale" content={meta.og?.locale} />
                      <meta property="og:locale:alternate" content={meta.og?.locale_alternate} />

                      {/* Twitter */}
                      <meta name="twitter:card" content={meta.twitter?.card} />
                      <meta name="twitter:title" content={meta.twitter?.title} />
                      <meta name="twitter:description" content={meta.twitter?.description} />
                      <meta name="twitter:image" content={meta.twitter?.image} />

                      {/* Дополнительные мета-теги */}
                      <meta http-equiv="content-language" content={meta.additional?.content_language} />
                      <meta name="facebook-domain-verification" content={meta.additional?.facebook_domain_verification} />
                  </Helmet>
                  :
                  <Helmet>
                      <title>àбанк • цінуємо стосунки • картка для виплат</title>
                      <meta name="keywords" content="Картка для виплат, абанк, банківські карти, карты онлайн, онлайн-банк, банковские услуги, без скрипта" />
                  </Helmet>
            }
            <div className="module-cards-container">
                <div className="content">
                <div className="module-cards-container-banner">
                    <Banner
                        img={null}
                        text={'CARDS_KDV_SUBTITLE-NEW'}
                        textMob={'CARDS_KDV_SUBTITLE-NEW'}
                        title={'CARDS_KDV_TITLE'}
                        toggleModal={null}
                        isMobile={isMobile}>
                    </Banner>
                </div>
                </div>
                <TabsNew modes={modes} isMobile={isMobile} page={'kdv-new'} toggle={this.toggleMode} mode={this.state.mode}>
                    <div className="wrapper" type={modes[0].mode}>
                        <div className="usage-block-container">
                            <UsageBlock isMobile={isMobile} page={page} data={kdv_usage_block_data} className="col-3-row-1"></UsageBlock>
                        </div>
                    </div>
                    <div className="wrapper" type={modes[1].mode}>
                        <div className="content">
                            <Table data={kdv_table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                            <div className="tariffs-desc">
                                {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                                <a className="link" href={tariffsKDV} target="_blank">
                                    {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                                    <img alt="href_img" src={share_icon}></img>
                                </a>
                            </div>
                        </div>
                        {app}
                    </div>
                    <div className="wrapper" type={modes[2].mode}>
                        <div className="content">
                            <QuestionsBlock isMobile={isMobile} page={page} data={kdv_questions}></QuestionsBlock>
                        </div>
                        {app}
                    </div>
                </TabsNew>
                <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}></FilesForDownload>

            </div>
        </>
    );
}
